import { LoadingButton } from "@mui/lab";
import { Box, Grid, Typography } from "@mui/material";
import { CheckoutContext } from "contexts/Checkout";
import { SubscriptionContext } from "contexts/Subscription";
import { useContext } from "react";
import { AddOnItemName } from "schemas/dashboard";

import { useCheckout } from "components/StripeCheckout/useCheckout";

import styles from "./styles";

const CustomerSupportAddOn = () => {
  const { addOnItems, applyAddOnLoading } = useContext(CheckoutContext);
  const { addOns } = useContext(SubscriptionContext);
  const { applyAddOnItem } = useCheckout();

  const exists = addOnItems?.find(
    (x) => x.name === AddOnItemName.customer_support,
  );

  const price = addOns[AddOnItemName.customer_support]?.price;

  const addToOrderButton = exists ? (
    <Box sx={{ px: 2, fontSize: 10, color: "green.main" }}>
      <strong>
        Added <Box component="i" className="fa-regular fa-check" />
      </strong>
    </Box>
  ) : (
    <LoadingButton
      disableElevation
      fullWidth
      variant="contained"
      sx={{ px: 2, ml: 1, borderRadius: 3 }}
      loading={applyAddOnLoading === AddOnItemName.customer_support}
      onClick={() =>
        applyAddOnItem({
          name: AddOnItemName.customer_support,
          quantity: 1,
        })
      }
    >
      + Add Account Setup
    </LoadingButton>
  );

  return (
    <Grid sx={styles.card}>
      <Box sx={styles.enhance}>Enhance Your Plan</Box>
      <Typography variant="h6" gutterBottom>
        Account Setup 💎
      </Typography>

      <Grid container alignItems="center" sx={{ mb: 2 }}>
        <Typography
          component="div"
          sx={{ color: "green.main", fontSize: 16, fontWeight: 600 }}
          gutterBottom
        >
          ${price}
        </Typography>
        <Box sx={[styles.annotationPrice, { fontWeight: 600 }]}>
          One-time fee
        </Box>
      </Grid>

      <Typography>
        Get your account setup reviewed by a human to increase your reply rate.
      </Typography>

      <Grid item xs={12} sx={{ mt: 2, ml: -2 }}>
        {addToOrderButton}
      </Grid>
    </Grid>
  );
};

export default CustomerSupportAddOn;
